<div a7ContentContainer
     [a7ContentContainerFocusSectionDelta]="60"
     class="content-container">
  <router-outlet></router-outlet>
</div>
<a7-chatbot></a7-chatbot>